/**
 * Check if any of the communities the user has access to has the feature given in the second argument
 * @param user
 * @param feature
 * @returns true if any of the communities the user has access to has the feature, false otherwise
 */
export function checkFeatureAvailabilityFromUser(user, feature) {
    var _a;
    if (!((_a = user === null || user === void 0 ? void 0 : user.communities) === null || _a === void 0 ? void 0 : _a.length))
        return false;
    const lowerCaseCommunityFeatures = user.communities.map((community) => {
        return Object.assign(Object.assign({}, community), { features: community.features.map((feature) => feature.toLowerCase()) });
    });
    return lowerCaseCommunityFeatures.some((community) => community.features.includes(feature.toLowerCase()));
}
